import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}


const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const AddQuizz = Loadable({
  loader: () => import('./views/Quizz/Add'),
  loading: Loading,
});
const EditQuizz = Loadable({
  loader: () => import('./views/Quizz/Edit'),
  loading: Loading,
});
const ListQuizz = Loadable({
  loader: () => import('./views/Quizz/List'),
  loading: Loading,
});
const AddContributors = Loadable({
  loader: () => import('./views/Contributors/Add'),
  loading: Loading,
});
const EditContributors = Loadable({
  loader: () => import('./views/Contributors/Edit'),
  loading: Loading,
});
const ListContributors = Loadable({
  loader: () => import('./views/Contributors/List'),
  loading: Loading,
});





// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Accueil', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/contributors/list', name: 'Contributeurs', component: ListContributors },
  { path: '/contributors/add', name: 'Nouveau contributeur', component: AddContributors },
  { path: '/contributors/edit/:id', name: 'Modifier un contributeur', component: EditContributors },
  { path: '/quizz/list', name: 'Liste des Quizz', component: ListQuizz },
  { path: '/quizz/add', name: 'Nouveau Quizz', component: AddQuizz },
  { path: '/quizz/edit/:id', name: 'Modifier un Quizz', component: EditQuizz },
  
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js